import { StringHash, UUID } from "@pdfking/tfunc"
import { GuidToString } from "@pdfking/tfunc"

import type { RemoteFile } from "../types/files/cached/RemoteFile"
import { ContentType } from "../types/files/ContentType"
import { VirtualFileType } from "../types/files/VirtualFileType"
import { PathContentType } from "./PathContentType"

export async function CreateRemoteFile({
  type,
  mirrors,
  file_meta,
  guid,
}: Partial<RemoteFile>): Promise<RemoteFile> {
  return {
    enum: VirtualFileType.REMOTE_FILE,
    type: type ?? PathContentType(mirrors || []) ?? ContentType.PDF,
    file_meta: file_meta || {},
    mirrors: mirrors ?? [],
    guid:
      guid ??
      GuidToString(
        mirrors && mirrors.length > 0 ? await StringHash(mirrors) : UUID()
      ),
  }
}
